// store.js
// 引入 axios
import toast from '@/components/toast/toast'
import axios from 'axios'

// axios 配置
axios.defaults.timeout = 30000;
axios.defaults.headers.post['Content-Type'] = 'application/json;';
axios.defaults.headers['X-Request-With'] = 'XMLHttpRequest'; // ajax请求方式
axios.defaults.responseType = 'json'; // POST传参序列化
axios.interceptors.request.use((config) => {
  if (config.method === 'post') {
    // config.data = qs.stringify(config.data);
  }
  return config;
}, (error) => {
  toast({
    message: error
  });
  return Promise.reject(error);
});

// 返回状态判断
// 返回状态截获
axios.interceptors.response.use((res) => {
  if (res.data.code === 401) {
    // 强制退出
    toast({
      message: '登录过期，请重新登录'
    });
    try {
      document.getElementsByClassName('close')[0].click();
    } catch (e) { }
    return Promise.reject(res);
  } else if (res.data.code !== 0) {
    toast({
      message: res.data.msg || '网络错误'
    });
    return Promise.reject(res.data);
  }
  return Promise.resolve(res.data);
}, (error) => {
  toast({
    message: '网络错误'
  });
  return Promise.reject(error);
});

let fetch = (function () {
  return function (url, params = {}) {
    return new Promise((resolve, reject) => {
      params = JSON.stringify(params);
      axios.post(url, params)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
})();

export default fetch;



// WEBPACK FOOTER //
// ./src/server/index.js